import React from 'react';
import './Backdrop.scss';

const backdrop = props => {
  const { show } = props;
  return show && <div className='backdrop'> </div>;
};
export default backdrop;
